import FeatureGates from '@atlaskit/feature-gate-js-client';
import { usePostOfficeRoute } from '@atlassian/post-office-context';

export const usePostOfficeSearchParams = () => {
	const route = usePostOfficeRoute();

	if (FeatureGates.checkGate('po-enable-query-params-screen-space-flags')) {
		return route?.searchParams ? Object.fromEntries(route.searchParams) : {};
	}

	return {};
};
